// src/Models/roleModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class RoleModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      roleID: data.roleId || data.roleID,
      roleName: data.roleName,
      description: data.description,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    return {
      roleId: Number(data.roleID || data.roleId || 0),
      roleName: data.roleName || '',
      description: data.description || '',
    };
  }
}
